import axios from 'axios'
import { Message } from 'element-ui'

const authRequest = axios.create({
  baseURL: '/api/admin/auth',
  timeout: 15000
})

authRequest.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

authRequest.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

// 获取验证码
export function getCaptcha() {
  return authRequest({
    url: '/captcha',
    method: 'get'
  })
}

// 登录
export function login(data) {
  return authRequest({
    url: '/login',
    method: 'post',
    data
  })
}

// 获取用户信息
export function getInfo() {
  return authRequest({
    url: '/info',
    method: 'get'
  })
}

// 退出登录
export function logout() {
  return authRequest({
    url: '/logout',
    method: 'post'
  })
}
